
$(function() {
  function getOptionParameterValue() {
    const queryString = window.location.search,
      regex = new RegExp("[?&]option(=([^&#]*)|&|#|$)"), // Create a regular expression to find the parameter and its value
      results = regex.exec(queryString)
    if (results && results[2]) { // If the parameter is found, return its value; otherwise, return null
      return decodeURIComponent(results[2].replace(/\+/g, " "))
    }
    return null
  }
  const acceptedOptionValues =['super', 'ttr', 'retirement'],
    mappedButtonIds = ['btn-1', 'btn-2', 'btn-3'],
    optionParameterValue = getOptionParameterValue()
  if (acceptedOptionValues.includes(optionParameterValue)) {
    $('.js-option').removeClass('is-active')
    const selectedIndex = acceptedOptionValues.indexOf(optionParameterValue),
      selectedButtonId = mappedButtonIds[selectedIndex],
      $selectedButtonOption = $(`#${selectedButtonId}`)
      $selectedButtonOption.trigger('click').addClass('is-active')
    console.log('Reached matched param:', {optionParameterValue, selectedButtonId, $selectedButtonOption}) //ToDo: remove this before going live
  }

  var defaultPortID = $('.chooserAction.is-active').attr('Pos');
  $('.portfolioPanel').hide();
  $('.portfolioPanel-'+defaultPortID).show();
  $('.chooserAction').click(function(){
    var id = $(this).attr('Pos');
    $('.chooserAction').removeClass('is-active');
    $(this).addClass('is-active');
    $('.portfolioPanel').hide();
    $('.portfolioPanel-'+id).show();
  });
});
